/**
 * Runtime configuration, served as /config.json so one build runs in every environment.
 * In production the container writes it from environment variables at start-up.
 */
export interface RuntimeConfig {
  /** "dev": a configured person, no sign-in. "oidc": Microsoft (and passwords, when the API
   * allows them). "password": email and password only. */
  authMode: "dev" | "oidc" | "password";
  devUser?: string;
  oidcAuthority?: string;
  oidcClientId?: string;
  oidcScope?: string;
}

const fallback: RuntimeConfig = { authMode: "dev", devUser: "alex@example.com" };

let loaded: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (loaded) return loaded;
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    loaded = res.ok ? { ...fallback, ...((await res.json()) as Partial<RuntimeConfig>) } : fallback;
  } catch {
    loaded = fallback;
  }
  return loaded;
}

export function currentConfig(): RuntimeConfig {
  return loaded ?? fallback;
}
